import UserInfo from "@ext/security/logic/User/UserInfo";

const localUserInfo: UserInfo = { name: "Admin", mail: "admin@gram.ax", id: "admin" };

export default localUserInfo;
